module.exports = __webpack_public_path__ + "media/images/proof_links/medium-1e9ab5ea3a15012527f126f25ecb16e0.svg";